import { gql, useLazyQuery } from "@apollo/client";
export const GET_CATALOG_LIST = gql`
  query getCdlCatalogList {
    getCdlCatalogList {
      name
      updatedAt
      updatedBy
      createdAt
      createdBy
      catalogType
    }
  }
`;

export function useGetCdlCatalogList() {
  const [
    getCdlCatalogList,
    {
      data: catalogList,
      loading: isLoadingCatalogList,
      error: errorCatalogList
    }
  ] = useLazyQuery(GET_CATALOG_LIST);
  return {
    getCdlCatalogList,
    catalogList,
    isLoadingCatalogList,
    errorCatalogList
  };
}
